/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileCard_manager = {
    readonly firstName: string;
    readonly lastName: string;
    readonly company: {
        readonly backgroundCheckPennyPrice: number;
        readonly dbsPennyPrice: number;
        readonly dbsOnlyPennyPrice: number;
        readonly renewalPennyPrice: number;
        readonly name: string;
        readonly verificationSuccessPennyPrice: number;
        readonly verificationFailurePennyPrice: number;
        readonly invoicing: {
            readonly dbsUsed: number;
            readonly dbsPrePurchased: number;
            readonly backgroundChecksUsed: number;
            readonly backgroundChecksPrePurchased: number;
            readonly renewalsUsed: number;
            readonly renewalsPrePurchased: number;
        } | null;
    };
    readonly " $refType": "ProfileCard_manager";
};
export type ProfileCard_manager$data = ProfileCard_manager;
export type ProfileCard_manager$key = {
    readonly " $data"?: ProfileCard_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileCard_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ProfileCard_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "backgroundCheckPennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dbsPennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dbsOnlyPennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "renewalPennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verificationSuccessPennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verificationFailurePennyPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "invoicing",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CompanyInvoicing",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dbsUsed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dbsPrePurchased",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "backgroundChecksUsed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "backgroundChecksPrePurchased",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "renewalsUsed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "renewalsPrePurchased",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cfb119e02874a18f99d54af2785366e7';
export default node;
